import { render, staticRenderFns } from "./activity_manage.vue?vue&type=template&id=96e8ab5e&scoped=true&"
import script from "./activity_manage.vue?vue&type=script&lang=js&"
export * from "./activity_manage.vue?vue&type=script&lang=js&"
import style0 from "./activity_manage.vue?vue&type=style&index=0&id=96e8ab5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e8ab5e",
  null
  
)

export default component.exports